import { QUERY_KEYS } from '../../../../consts';
import { saveUserSignDataService } from '../../../../services/sign/save-user-sign-data.service';
import { getAtomWithMutation } from '../../../../utils';

export const saveUserSignDataAtom = getAtomWithMutation({
  mutationKey: QUERY_KEYS.USER.USER_INFO,
  mutationFn: () => saveUserSignDataService,
});
